var Chaplin, PurchasePopupView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/purchase-popup');

View = require('views/base/view');

Chaplin = require('chaplin');

module.exports = PurchasePopupView = (function(_super) {
  __extends(PurchasePopupView, _super);

  function PurchasePopupView() {
    _ref = PurchasePopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  PurchasePopupView.prototype.template = template;

  PurchasePopupView.prototype.className = 'popup';

  PurchasePopupView.prototype.tagName = 'div';

  PurchasePopupView.prototype.id = 'purchase-popup';

  PurchasePopupView.prototype.autoRender = true;

  PurchasePopupView.prototype.container = 'body';

  PurchasePopupView.prototype.listen = {
    'catalogue:hideDescription mediator': 'closePopup'
  };

  PurchasePopupView.prototype.events = {
    'click .btn-close': 'close',
    'click input[type="submit"]': 'submitForm',
    'click input[type="reset"]': 'cancelForm'
  };

  PurchasePopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  PurchasePopupView.prototype.close = function() {
    return this.publishEvent('catalogue:hideAllDescriptions');
  };

  PurchasePopupView.prototype.cancelForm = function() {
    return this.publishEvent('catalogue:hideAllDescriptions');
  };

  PurchasePopupView.prototype.submitForm = function(e) {
    var def, serializedForm,
      _this = this;
    e.preventDefault();
    serializedForm = this.$('form').serialize();
    def = this.model.pushPurchaseMessage(serializedForm);
    def.done(function() {
      return _this.showSuccessMessage();
    });
    return false;
  };

  PurchasePopupView.prototype.showSuccessMessage = function() {
    this.$('.success-area').fadeIn();
    return this.$('.form-area').hide();
  };

  return PurchasePopupView;

})(View);
